import { isOrganizationAdmin } from "@repo/auth/lib/helper";
import { SettingsLayout } from "@saas/settings/components/SettingsLayout";
import { AppNotFound } from "@saas/shared/components/AppNotFound";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings",
)({
	beforeLoad: ({ context }) => ({
		isOrganizationAdmin: isOrganizationAdmin(
			context.organization,
			context.session.user,
		),
	}),
	component: OrganizationSettingsLayout,
	notFoundComponent: () => <AppNotFound />,
});

function OrganizationSettingsLayout() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	return (
		<SettingsLayout isOrganizationAdmin={isOrganizationAdmin}>
			<Outlet />
		</SettingsLayout>
	);
}
